import React from 'react'
import { Rotas } from './routes';
import { CssBaseline  } from '@mui/material';
import { EventProvider } from './context/EventContext';
import { OlderEventProvider  } from './context/OlderEventContext';
import { ManagerContextProvider } from './context/ManagerContext';

export default function App() {
  return  (
    <ManagerContextProvider>
    <EventProvider>
      <OlderEventProvider>
        <CssBaseline/>
        <Rotas />
      </OlderEventProvider>
    </EventProvider>
    </ManagerContextProvider>
  );
}